export enum HeaderClass {
  RIGHT = 'right',
  TEXT_ALIGN_RIGHT = 'text-align-right',
  CAPITALIZE = 'capitalize',
  AMOUNT_FULL_WEIGHT = 'amount-full-width',
  COMPACT = 'compact'
}
